import { convertToURLParams } from '@/config/utils'
import type {
	BatchActionResponse,
	BatchDBCRequest,
	DBCActionMessageResponse,
	DBCDiffResponse,
	DBCFileResponse,
	DBCResponse,
	DbcFilter,
	EditDBCParserInput,
	PaginatedDBCResponse,
	ParsedDBCResponse,
	SingleDBCResponse,
} from '../dbcApi'
import type { Filters } from '../deviceApi'
import { demoApi } from './db'

export type DbcParsersResponse = {
	data: DBCResponse[]
	count: number
}

export const dbcApi = {
	getDBCLists: async (
		_params?: { page?: number; per_page?: number },
		_filters?: DbcFilter,
	): Promise<PaginatedDBCResponse> => {
		// TODO: Implement server side pagination and filtering for dbc-parsers in demo mode.
		const res = await demoApi.get<DBCResponse[]>('/v1/dbcs')
		// TODO: implement category wise(custom,obd,j1939) count summary for demo
		return {
			count: res.length,
			data: res,
		}
	},
	getDBC: async (dbcID: string): Promise<SingleDBCResponse> => demoApi.get(`/v1/dbcs/${encodeURIComponent(dbcID)}`),
	getDBCFile: async (dbcID: string): Promise<DBCFileResponse> =>
		demoApi.get(`/v1/dbcs/${encodeURIComponent(dbcID)}/dbc`),
	getParsedDBC: async (dbcID: string): Promise<ParsedDBCResponse> =>
		demoApi.get(`/v1/dbcs/${encodeURIComponent(dbcID)}/json`),
	getDBCDiff: async (dbcID: string, body: FormData): Promise<DBCDiffResponse> =>
		demoApi.post(`/v1/dbcs/${encodeURIComponent(dbcID)}/diff`, body),
	getDbcParsers: async (limit: number, page: number, filters: Filters): Promise<DbcParsersResponse> => {
		const query = convertToURLParams(filters)
		const res = await demoApi.get<DBCResponse[]>(`/v1/dbc-parsers?limit=${limit}&page=${page}&${query}`)
		return { data: res, count: res.length }
	},

	createDbcParser: async (data: FormData): Promise<void> =>
		demoApi.post('/v1/dbc-parsers', data, { headers: { 'Content-Type': 'multipart/form-data' } }),

	deleteDbcParser: async (parserId: string): Promise<void> => demoApi.delete(`/v1/dbc-parsers/${parserId}`),

	createDBCParser: async (body: FormData): Promise<DBCResponse> => demoApi.post('/v1/dbcs', body),
	updateDBCParsing: async (dbcID: string, body: FormData): Promise<SingleDBCResponse> =>
		demoApi.put(`/v1/dbcs/${encodeURIComponent(dbcID)}/update`, body),
	updateDBCSettings: async (dbcID: string, body: EditDBCParserInput): Promise<DBCActionMessageResponse> =>
		demoApi.put(`/v1/dbcs/${encodeURIComponent(dbcID)}`, body),
	deleteDBC: async (dbcID: string): Promise<DBCActionMessageResponse> =>
		demoApi.delete(`/v1/dbcs/${encodeURIComponent(dbcID)}`),
	startDBCParser: async (dbcID: string): Promise<SingleDBCResponse> =>
		demoApi.put(`/v1/dbcs/${encodeURIComponent(dbcID)}/start`),
	stopDBCParser: async (dbcID: string): Promise<SingleDBCResponse> =>
		demoApi.put(`/v1/dbcs/${encodeURIComponent(dbcID)}/stop`),
	// TODO: implement batchDeleteDBCs for demo
	batchDeleteDBCs: async (_body: BatchDBCRequest): Promise<DBCActionMessageResponse> => ({
		message: 'Not implemented',
	}),
	// TODO: implement batchStartDBCs for demo
	batchStartDBCs: async (_body: BatchDBCRequest): Promise<BatchActionResponse> => ({
		results: 'Not implemented',
	}),
	// TODO: implement batchStopDBCs for demo
	batchStopDBCs: async (_body: BatchDBCRequest): Promise<BatchActionResponse> => ({
		results: 'Not implemented',
	}),
}
